module.exports = __webpack_public_path__ + "static/images/icon-twitter.6640c7649bee33786e7f97d608910bd0.svg";